export default __webpack_public_path__ + "static/image-2021-12-21-10-15-21-631-85a2356a73fc216e8225ab8ed2450b0f.png";